// extracted by mini-css-extract-plugin
export default {"root":"_3bkVJ","align-items-center":"nEyy5","alignItemsCenter":"nEyy5"};